import React, {useState, useMemo} from "react";
import {SetMetaData} from './../../helper/page-title';
import useInfiniteList from "../../hooks/infinite-list";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import FilterInput from "../../components/form/filter/filter-input";
import normalizeFilters from "../../helper/filter/normalize-filter";
import {SettingDropdownUi, RowDataUi} from "../../components/form/master-table/ui-static";
import {post_api_call,
        error_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import ModalMasterDetail from "../../modal/master-detail";
import FormDataNomi from "../../data/formData/school/nomination";
const {
    masterTableFields,
    fieldNomiView1,
    fieldNomiView2,
    fieldNomiView3,
} = FormDataNomi;

function NominationList(props){
    SetMetaData("Manage Admins", "", "");
    const [filterData, setFilterData] = useState({});
    const [modalLoader, setModalLoader] = useState({detail: false});
    const [modalToggle, setModalToggle] = useState({detail: false});
    //Single Details
    const [detailedNomiData, setDetailedNomiData] = useState({});
    // const [refreshKey, setRefreshKey] = useState(0);
    const { columnSettings, updateColumn } = useColumnSettings({
            id: true,
            email: true,
            name_address: true,
            created_at: true
        });
    
    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {}),
        [filterData]
    );

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["manage_nomination", 0],
        apiCall: payload => post_api_call("nominations", payload),
                limit: 100,
                extraPayload: {
                    fetch_type: "manage_nomination",
                    filter: normalizedFilter
                }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    //View Data
    const loadViewModal = async(e, load_type, modal_data) => {
        e.preventDefault();
        try{
            //Page Loading
            toggleModal(e, load_type, true);
            setModalLoader({...modalLoader, [load_type]: true});
            // console.log(load_type, modal_data, 'hhhhh')
            if(load_type === 'detail'){
                modal_data.nominating_type = modal_data.nomination
                                        ? (modal_data.nomination?.school_count ? 'A group of schools' : 'Only one school')
                                        : '';
                modal_data.is_affi_internationally = modal_data.nomination
                                                ? (modal_data.nomination?.organisation_name ? 'Yes' : 'No')
                                                : '';
                // modal_data.start_end_month = modal_data.nomination
                //                         ? `${modal_data.nomination?.start_month_name} - ${modal_data.nomination?.end_month_name}`
                //                         : '';
                modal_data.school_count = modal_data.nomination?.school_count
                                    ? (modal_data.nomination?.school_count > 10 ? '10+' : modal_data.nomination?.school_count)
                                    : '';
                setDetailedNomiData({...modal_data});
            }
            setModalLoader({...modalLoader, [load_type]: false});
        }catch(error){
            error_api_call({error: `admin|school|nomination|loadViewModal|${error}`});
            alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
        }
    }
    //Update Input
    const updateInput = (form_type, attrName, value) => {
        try {
            if(form_type === "filter"){
                let fields = {...filterData};
                fields[attrName] = value;
                setFilterData({...fields});
            }
        } catch (error) {
            console.error(error);
            error_api_call({
                error: `admin/screens/school/nomination|updateInput|${error}`
            });
        }
    };
    // Toggle Modal
    const toggleModal = (e, modal_type, toggleState) => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
        }catch(error){
            console.log(error)
        }
    }

    return (
        <>
        <div className="row">
          <InfiniteListWrapper
              dataLength={masterTableData.length}
              isLoading={isLoading}
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              isFetchingNextPage={isFetchingNextPage}
              emptyMessage="No Record found!"
          >
              <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                      {/* SETTINGS */}
                      <SettingDropdownUi
                          checkedData={columnSettings}
                          fields={masterTableFields}
                          updateColumn= {(field, value) => updateColumn(field, value)}
                      />

                      {/* TABLE */}
                      <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                          <table className="table">
                              <thead>
                              <tr>
                                  {masterTableFields.map((col, i) => (
                                  (typeof col.accessRoleIds === "undefined" ||
                                      props.userRoleIds.some(role =>
                                      col.accessRoleIds.includes(role)
                                      )) &&
                                      columnSettings[col.field.name] && (
                                          <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                          {col.title}
                                          {col.is_searchable && (
                                              <FilterInput
                                                  formType="filter"
                                                  field={col?.field}
                                                  data={filterData}
                                                  selectOptions={{}}
                                                  _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, field, value)}
                                              />
                                          )}
                                          </th>
                                      )
                                  ))}
                                  <th>Action</th>
                              </tr>
                              </thead>

                              <tbody>
                              {isLoading ? (
                                  <tr>
                                      <td colSpan="20" className="text-center p-4">
                                          <img
                                              alt="Loader"
                                              src={require("../../assets/images/Image-Loader.gif")}
                                          />
                                      </td>
                                  </tr>
                              ) : (
                                  masterTableData.length > 0 
                                  ? (
                                      masterTableData.map((row, index) => {
                                      return (
                                          <tr
                                              key={index}
                                          >

                                              {masterTableFields.map((tbl, i) => (
                                                  (typeof tbl.accessRoleIds === "undefined" ||
                                                  props.userRoleIds.some(role =>
                                                      tbl.accessRoleIds.includes(role)
                                                  )) &&
                                                  columnSettings[tbl.field.name] && (
                                                  <td key={i}>
                                                      {/* {row[tbl.fetch_key]} */}
                                                      <RowDataUi
                                                          fetch_key={tbl.fetch_key}
                                                          data={row}
                                                          data_type={tbl.data_type ?? "text"}
                                                      />
                                                  </td>
                                                  )
                                              ))}

                                              <td className="d-flex">
                                                  <button onClick={(e) => loadViewModal(e, 'detail', row)} className="btn btn-sm btn-twitter" title="View Data"><i className="mdi mdi-eye"></i></button>
                                              </td>
                                          </tr>
                                      );
                                      })
                                  )
                                  : 
                                  <tr>
                                      {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                      <td colSpan="20">
                                      <div className="no-fellow text-center mt-4">
                                          {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                          <p className="pt-4 head">{"No Record Found!"}</p>
                                      </div>
                                      </td>
                                  </tr>
                              )}
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </InfiniteListWrapper>
        </div>
        {/* View Nomination Details */}
        <ModalMasterDetail
            data={detailedNomiData}
            isShow={modalToggle.detail}
            _toggleModal={(e, state) => toggleModal(e, 'detail', state)}
            loader={modalLoader.detail}
            _formData={[{label: "About Your School", fields: [...fieldNomiView1]},
                        {label: "Nomination to IFSPD Europe Future Global Leaders Fellowship", fields: [...fieldNomiView2]},
                        {label: "Contact Details", fields: [...fieldNomiView3]}
                    ]}
            title={"School Nomination Details"}
        />
        </>
    )    
}

export default NominationList;